import { baseApi } from './baseApi';

export const repairApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRepairTickets: builder.query({
      query: (params) => ({
        url: '/repairs',
        params,
      }),
      providesTags: ['RepairTicket'],
    }),
    getRepairTicketById: builder.query({
      query: (id) => `/repairs/${id}`,
      providesTags: (result, error, id) => [{ type: 'RepairTicket', id }],
    }),
    createRepairTicket: builder.mutation({
      query: (body) => ({
        url: '/repairs',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['RepairTicket'],
    }),
    updateRepairTicket: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/repairs/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'RepairTicket', id },
        'RepairTicket',
      ],
    }),
    addRepairItem: builder.mutation({
      query: ({ ticketId, body }) => ({
        url: `/repairs/${ticketId}/items`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { ticketId }) => [
        { type: 'RepairTicket', id: ticketId },
      ],
    }),
    removeRepairItem: builder.mutation({
      query: ({ ticketId, itemId }) => ({
        url: `/repairs/${ticketId}/items/${itemId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { ticketId }) => [
        { type: 'RepairTicket', id: ticketId },
      ],
    }),
    deliverAndBillRepairTicket: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/repairs/${id}/deliver-and-bill`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'RepairTicket', id },
        'RepairTicket',
        'SalesOrder',
        'Stock',
      ],
    }),
  }),
});

export const {
  useGetRepairTicketsQuery,
  useGetRepairTicketByIdQuery,
  useCreateRepairTicketMutation,
  useUpdateRepairTicketMutation,
  useAddRepairItemMutation,
  useRemoveRepairItemMutation,
  useDeliverAndBillRepairTicketMutation,
} = repairApi;
